











import Vue from "vue";
import { ThisTypedComponentOptionsWithRecordProps } from "vue/types/options";
import { ServiceTile } from "@/requests/mainApi/models/ServiceTile";


interface Data {}

interface Methods {}

interface Computed {}

interface Props {
  service: ServiceTile | null;
  onClick: () => void | null
  disabled?: boolean | null
}

export default Vue.extend({
  name: "Service",
  props: {
    service: null,
    onClick: null,
    disabled: null,
  },
  computed: {},
  methods: {},
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
